import { Box, Button, Typography } from "@mui/material";
import { serviceData } from "./serviceData";
import Service from "./Service";
import React from "react";

import "./services.css";

export default function Services() {
  const isMobile = window.innerWidth <= 768; 

  return (
    <section id="services">
      <Box className="services-container">
        <Typography className="services-heading" variant="h4" id={!isMobile ? "fromTop" : ""}>
          My
        </Typography>
        <Box className="services-main">
          {serviceData.map((service, index) => (
            <Service
              key={index}
              btnText={service.btnText}
              title={service.title}
              description={service.description}
              icon={service.child}
              id={isMobile ? "" : `${(index == 0 && "fromLeft") || (index == 1 && "fromTop") || (index == 2 && "fromRight") || (index == 3 && "fromRight")}`}
            />
          ))}
        </Box>
      </Box>
    </section>
  );
}
